import 'babel-polyfill';
import videojs from 'video.js';

/* eslint-disable */
require('videojs-overlay');
require('videojs-markers');

import bootstrap from './bootstrap';
import settings from './settings';

import './css/skin.css';
import 'video-js-core/src/sharing/videojs-share.css';
import 'video-js-core/src/playlistControls/base.css';
import 'node_modules/videojs-overlay/dist/videojs-overlay.css';
import 'node_modules/videojs-markers/dist/videojs.markers.css';
/* eslint-enable */

// videojs logging API: http://docs.videojs.com/tutorial-debugging.html
videojs.log.level(settings.loggingLevel);

bootstrap();



// WEBPACK FOOTER //
// ./src/index.js